import { Close } from '@mui/icons-material';
import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import { ErrorStatusIcon, SuccessStatusIcon } from 'components/SVG';
import React from 'react';
import { useStatusBarStore } from 'stores';
import { SparkButton } from 'sharedComponents/UI';
import { useMemoriesQueueJob } from 'hooks/memory';

import { BreathingSparkAnimation } from 'components/Animations';
import { useNavigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';

function MemoryCreation() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = React.useState(true);
  const isComplete = useStatusBarStore((state) => state.isComplete);
  const isRunning = useStatusBarStore((state) => state.isRunning);
  const statusBarID = useStatusBarStore((state) => state.statusBarID);
  const resetStatusBarStore = useStatusBarStore(
    (state) => state.resetStatusBarStore
  );
  const percentageComplete = useStatusBarStore(
    (state) => state.percentageComplete
  );
  const { isError } = useMemoriesQueueJob(statusBarID);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleViewClick = () => {
    navigate(`${SPARK_ROUTES.MEMORIES}/${statusBarID}`);
    resetStatusBarStore();
  };

  if (!isVisible) {
    if (isComplete) resetStatusBarStore();
    return null;
  }

  return (
    <Grid
      item
      xs={12}
      bgcolor='white'
      borderBottom={(theme) => `1px solid ${theme.palette.borderColor}`}
    >
      {isError && (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Box sx={{ ml: 2, display: 'flex', alignItems: 'center' }}>
            <ErrorStatusIcon width={28} height={28} />
            <Typography
              variant='h5'
              sx={{
                fontFamily: 'Mont-SemiBold',
                fontSize: '20px',
                color: '#000000',
                ml: 2,
              }}
            >
              Memory Creation Error
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <Close
              sx={{ cursor: 'pointer', color: '#000000' }}
              onClick={handleClose}
            />
          </Box>
        </Grid>
      )}

      {isComplete && (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Box sx={{ ml: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
            <SuccessStatusIcon width='28' height='28' />
            <Typography
              variant='h5'
              sx={{
                fontFamily: 'Mont-SemiBold',
                fontSize: '20px',
                color: '#000000',
              }}
            >
              Memory Creation Completed
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <SparkButton
              variant='contained'
              sx={{ mr: 2 }}
              onClick={handleViewClick}
            >
              View
            </SparkButton>
            <Close
              sx={{ cursor: 'pointer', color: '#000000' }}
              onClick={handleClose}
            />
          </Box>
        </Grid>
      )}

      {isRunning && (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 1,
          }}
        >
          <Box sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <BreathingSparkAnimation width={30} height={30} />
            <Typography
              variant='h5'
              sx={{
                fontFamily: 'Mont-SemiBold',
                fontSize: '20px',
                color: '#000000',
              }}
            >
              Creating Memory
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: 2,
              width: '20%',
              gap: 1,
            }}
          >
            <Box sx={{ width: '100%' }}>
              <LinearProgress
                sx={{ height: '8px', borderRadius: '10px' }}
                variant='determinate'
                value={percentageComplete}
              />
            </Box>
            <Close
              sx={{ cursor: 'pointer', color: '#000000' }}
              onClick={handleClose}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default MemoryCreation;
